const TEN_GODS = {
  same: 'KiepTai',
  same_diff: 'TyKien',
  day_generates: 'ThucThan',
  day_generates_diff: 'ThuongQuan',
  generates_day: 'ThienAn',
  generates_day_diff: 'ChinhAn',
  day_overcomes: 'ThienTai',
  day_overcomes_diff: 'ChinhTai',
  overcomes_day: 'ThienQuan',
  overcomes_day_diff: 'ChinhQuan'
};

const GENERATES = {
  Moc: 'Hoa',
  Hoa: 'Tho',
  Tho: 'Kim',
  Kim: 'Thuy',
  Thuy: 'Moc'
};

const OVERCOMES = {
  Moc: 'Tho',
  Tho: 'Thuy',
  Thuy: 'Hoa',
  Hoa: 'Kim',
  Kim: 'Moc'
};

const getRelationKey = (dayElement, targetElement) => {
  if (dayElement === targetElement) return 'same';
  if (GENERATES[dayElement] === targetElement) return 'day_generates';
  if (GENERATES[targetElement] === dayElement) return 'generates_day';
  if (OVERCOMES[dayElement] === targetElement) return 'day_overcomes';
  if (OVERCOMES[targetElement] === dayElement) return 'overcomes_day';
  return 'unknown';
};

export function getTenGod(dayElement, targetElement, samePolarity) {
  const relationKey = getRelationKey(dayElement, targetElement);

  if (relationKey === 'same') {
    return samePolarity ? TEN_GODS.same : TEN_GODS.same_diff;
  }

  if (relationKey === 'unknown') return 'Other';

  const polarityKey = samePolarity ? relationKey : `${relationKey}_diff`;
  return TEN_GODS[polarityKey] || 'Other';
}
